// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/a74215276aa080596740.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"63c3edb8c4adc6859f8b","139":"f9521217fab3754bf79a","140":"ad5696c2d13254ee858c"}[chunkId] + ".chunk.js";
};